var _g, _path, _path2, _ellipse, _circle, _circle2, _circle3, _ellipse2, _circle4, _circle5, _circle6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarIconBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    fill: "none",
    viewBox: "0 0 61 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "M8.08 9.549c-2.1069 0-3.8163 1.745-3.8163 3.8958v25.9715c0 2.1508 1.7094 3.8958 3.8164 3.8958h1.2721c0 4.3015 3.4189 7.7914 7.6328 7.7914s6.5648-3.2037 6.5648-7.5053l11.245-.2861c0 4.3015 3.4189 7.7914 7.6328 7.7914 4.214 0 7.6328-3.4899 7.6328-7.7914h2.5443c1.4073 0 2.5442-1.1606 2.5442-2.5972s-1.1369-2.5971-2.5442-2.5971v-9.3092c0-1.3797-.5327-2.7027-1.4868-3.6766l-6.146-6.2738c-.9541-.9739-2.2501-1.5177-3.6017-1.5177h-4.0311v-3.8957c0-2.1508-1.7094-3.8957-3.8164-3.8957zm29.2591 12.9858h4.0311l6.1459 6.2738v1.5177h-10.177zM13.1686 43.3121c0-1.0332.4021-2.0241 1.1178-2.7547s1.6864-1.1411 2.6986-1.1411 1.9829.4105 2.6986 1.1411 1.1178 1.7215 1.1178 2.7547-.4021 2.0241-1.1178 2.7547-1.6864 1.141-2.6986 1.141-1.9829-.4104-2.6986-1.141-1.1178-1.7215-1.1178-2.7547m29.259-3.8958c1.0122 0 1.9829.4105 2.6986 1.1411s1.1178 1.7215 1.1178 2.7547-.4021 2.0241-1.1178 2.7547-1.6864 1.141-2.6986 1.141-1.9829-.4104-2.6986-1.141-1.1178-1.7215-1.1178-2.7547.4021-2.0241 1.1178-2.7547 1.6865-1.1411 2.6986-1.1411"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9DD3FF",
    d: "M34.3252 9.0161c2.1114.0003 3.824 1.764 3.8242 3.9375v3.9375h4.0401c1.3546 0 2.6541.5499 3.6103 1.5342l6.1602 6.3408c.9562.9844 1.4902 2.3223 1.4902 3.7168v9.4082c1.4101.0003 2.5496 1.1734 2.5498 2.625 0 1.4518-1.1395 2.6248-2.5498 2.625h-1.5967c-.249-4.628-4.0787-8.3037-8.7676-8.3037s-8.5186 3.6758-8.7675 8.3037h-8.2032c-.2723-4.6059-4.0923-8.2568-8.7666-8.2568-4.6712 0-8.49 3.6463-8.7666 8.248C6.5833 43.0033 5 41.2935 5 39.2036v-26.25c.0002-2.1736 1.7136-3.9375 3.8252-3.9375zm3.8242 21h10.2002v-1.5332l-6.1601-6.3418h-4.0401z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#89CAFF",
    d: "M5 12.9543c3.4995 7.8951 6.4798 13.1437 14.7168 19.7295 4.5297 3.6217 9.7959 6.6078 14.8262 8.9063a8.77 8.77 0 0 0-.2246 1.5517h-8.208c-.2488-4.6281-4.0794-8.3045-8.7696-8.3046-4.6867 0-8.5164 3.6707-8.7705 8.2939C6.5773 42.9961 5.0001 41.29 5 39.2043z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9198,
    cy: 43.6674,
    fill: "#5EAEED",
    rx: 7.8182,
    ry: 7.7402
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6562,
    cy: 43.2597,
    r: 7.7402,
    fill: "#89CAFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6546,
    cy: 43.2598,
    r: 3.7562,
    fill: "#E5F4FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6556,
    cy: 43.2596,
    r: 3.1126,
    fill: "#F4F7FC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.7713,
    cy: 43.6674,
    fill: "#5EAEED",
    rx: 7.8182,
    ry: 7.7402
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.25,
    cy: 43.2597,
    r: 7.7402,
    fill: "#89CAFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2483,
    cy: 43.2596,
    r: 3.7562,
    fill: "#E5F4FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2494,
    cy: 43.2596,
    r: 3.1126,
    fill: "#F4F7FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.4277 11.2314h47v22h-47z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarIconBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/car-icon-big.964acab19a334c42a26eacc9c6b43e3d.svg";